import React from 'react'
import { ClockIcon } from '@heroicons/react/24/outline'
import { TimerConfig } from '@/redux/slices/timerConfigurationSlice'
import { calculateTotalGameplayLength, TimerMode } from './types'

interface GameplayLengthProps {
  config: TimerConfig
}

export const GameplayLength: React.FC<GameplayLengthProps> = ({ config }) => {
  return (
    <div className=''>
      {config.mode === TimerMode.MANUAL_MODE ? (
        <div className='p-4 rounded-md bg-slate-50'>
          <div className='flex items-center gap-2'>
            <ClockIcon className='w-5 h-5 text-dark-blue' />
            <h3 className='text-lg font-medium text-dark-blue'>
              Manual Mode Active
            </h3>
          </div>
          <p className='mt-2 text-gray-600'>
            Timer is set to manual control. You'll need to start and end each
            round manually using the timer controls.
          </p>
          <p className='mt-1 text-sm text-gray-500'>
            No automatic timing or gameplay length estimation available in this
            mode.
          </p>
        </div>
      ) : (
        <div className='p-4 rounded-md bg-slate-50'>
          <div className='flex items-center gap-2'>
            <ClockIcon className='w-5 h-5 text-dark-blue' />
            <h3 className='text-lg font-medium text-dark-blue'>
              Estimated Gameplay Length
            </h3>
          </div>
          <p className='mt-2 text-gray-600'>
            Total estimated gameplay time:{' '}
            <span className='font-semibold'>
              {calculateTotalGameplayLength(config)} minutes
            </span>
          </p>
          <p className='mt-1 text-sm text-gray-500'>
            This is based on the sum of all phase durations across all rounds.
          </p>
        </div>
      )}
      {config.mode !== TimerMode.MANUAL_MODE && (
        <div className='bg-amber-50 border-l-4 border-amber-500 p-3 rounded-r-md mt-6'>
          <div className='flex items-start'>
            <div className='flex-shrink-0'>
              <img
                src='/icons/caution.svg'
                alt='Info'
                className='text-amber-500'
              />
            </div>
            <div className='ml-3'>
              <p className='text-sm text-amber-700 font-medium'>
                Note: The estimated gameplay time does not account for
                adjudication time between rounds. Professors may need additional
                time to review and finalize student decisions before proceeding
                to the next round.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
